// The Page copy screen for a branching product (Edward, 2026-10-29: "a page
// one for Decision Builder that's interactive, and then there can be
// multiple branches"): the interactive page once, then one box per branch
// holding only that branch's own pages. The server marks the stages every
// branch shares (`shared`, the rule the page builds use) and numbers and
// names the branches (`branch_number`, `branch_name`). Returns null when no
// stage is shared, so every other product keeps one box per planned page.
export function branchLayout(pages) {
  const list = (pages || []).filter(Boolean);
  if (!list.some(p => (p.stages || []).some(st => st && st.shared))) return null;
  // Each shared page once, with the copy from the first branch that carries
  // it (an older strategy wrote it in full only under the first branch).
  const shared = [];
  list.forEach(p => (p.stages || []).forEach(st => {
    if (!st || !st.shared) return;
    const key = st.stage ?? st.page;
    const seen = shared.find(s => s.key === key);
    if (!seen) shared.push({ key, stage: st });
    else if (!(seen.stage.blocks || []).length && (st.blocks || []).length) seen.stage = st;
  }));
  const branches = list.map((p, i) => ({
    index: i,
    page: p,
    number: p.branch_number || i + 1,
    name: p.branch_name || p.page_name,
    stages: (p.stages || []).filter(st => st && !st.shared),
  }));
  return { shared: shared.map(s => s.stage), branches };
}
